import { useRef } from 'react';

export default function useEventAwaiting(): [() => Promise<void>, () => void] {
  const waitQueue = useRef<(() => void)[]>([]);

  const awaitEvent = async () => {
    return new Promise<void>(resolve => {
      waitQueue.current.push(resolve);
    });
  }

  const handleEvent = () => {
    waitQueue.current.forEach(resolve => resolve());
    waitQueue.current = [];
  }

  return [awaitEvent, handleEvent];
}
